import { FormControl, Input, InputLabel, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { UserDetailsContext } from "../../HardwareDetails/HardwareDetails";
import { ActionsModal } from "../ActionsModal";
import { ActionStatusContext } from "../Actions";
import { generateReportAccessoryIssueTicket } from "../../../helper/generateTicket";
import { createZendeskTicket } from "../../../resource/bff";

export default function AccessoryIssuesModal(props) {
  const [accessory, setAccessory] = useState("");
  const [issue, setIssue] = useState("");
  const userDetails = useContext(UserDetailsContext);
  const { setIsLoading, showActionResponse, setIsActionSuccess } =
    useContext(ActionStatusContext);

  const onSubmit = async (event) => {
    event.preventDefault();
    props.onClose();
    setIsLoading(true);
    const ticket = generateReportAccessoryIssueTicket(
      userDetails.workingOffice.country,
      userDetails.homeOffice.name,
      userDetails.homeOffice.country,
      userDetails.employeeNumber,
      accessory,
      issue
    );
    try {
      await createZendeskTicket(ticket);
      setIsActionSuccess(true);
    } catch (error: any) {
      setIsActionSuccess(false);
    } finally {
      setAccessory("");
      setIssue("");
    }
    setIsLoading(false);
    showActionResponse();
  };

  return (
    <ActionsModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      heading={"Report"}
      title={"Accessory Issues"}
      isFormValid={accessory != "" && issue != ""}
      onSubmit={onSubmit}
    >
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "25px" }}
      >
        <InputLabel id={"specify-accessory-label"}>
          <Typography display={"inline"}>Specify the accessory</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        <Input
          multiline
          maxRows={5}
          aria-labelledby={"specify-accessory-label"}
          value={accessory}
          onChange={(e) => setAccessory(e.target.value)}
        />
      </FormControl>
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "32px" }}
      >
        <InputLabel id={"specify-issue-label"}>
          <Typography display={"inline"}>Specify the issue</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        <Input
          multiline
          maxRows={5}
          aria-labelledby={"specify-issue-label"}
          value={issue}
          onChange={(e) => setIssue(e.target.value)}
        />
      </FormControl>
    </ActionsModal>
  );
}
